<template>
  <div class="container">
    <div class="dashboard columns">
      <div class="column column-55">
        <div class="column-header">
          <h2>Scenes</h2>
        </div>
        <div class="column-body">
          <Scenes :draggable="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import Scenes from "../../components/Dashboard/Scenes.vue";
import fake from "../../fake";

export default {
  methods: {
    ...mapMutations(["setSelectedScene"])
  },
  mounted() {
    this.setSelectedScene(null);
  },
  components: {
    Scenes
  }
};
</script>

<style lang="scss">
</style>
